import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import AdjustmentInBatchForm from '../../components/AdjustmentInBatchForm'
import DownloadCsvButton from '../../components/DownloadCsvButton'
import InvalidStructureTable from '../../components/InvalidStructureTable'
import { actions } from '../../StockAdjustmentInBatchState'
import DownloadTemplate from 'src/features/base/components/DownloadTemplate'
import * as S from './AdjustmentInBatchPage.styles'

export default () => {
  const dispatch = useDispatch()

  useEffect(() => () => {
    dispatch(actions.resetUploadPage())
  }, [dispatch])

  return (
    <S.Wrapper>
      <S.Title>Ajuste de Estoque por Planilha</S.Title>
      <DownloadTemplate
        href='/adjustment_template.xlsx'
      />
      <AdjustmentInBatchForm />
      <DownloadCsvButton />
      <InvalidStructureTable />
    </S.Wrapper>
  )
}
